import React, { memo } from 'react';
import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import SolidProgressBar from '@ertelecom/ui-react/components/progressBars/SolidProgressBar';

import clientRouterIcon from '../../../../static/images/clientRouter.svg';

const ClientRouterContainer = styled.div`
    background: ${ COLORS.white };
    border: 1px solid ${ COLORS.grey };
    border-radius: 4px;
    min-height: 200px;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 30px 150px 30px 60px;
    margin: 10px auto 50px;
    @media (max-width: 1400px) {
        margin: 10px auto;
        padding-right: 60px;
    }
    @media (max-width: 1200px) {
        margin: 10px auto;
        padding: 30px 45px 30px 40px;
    }
    @media (max-width: 1000px) {
        flex-direction: column;
        padding: 10px 60px;
    }
    @media (max-width: 500px) {        
        padding: 25px;
    }
`;

const RouterInfo = styled.div`
    display: flex;
    flex-wrap: nowrap;
    border-right: 1px solid ${COLORS.grey};
    padding: 10px 80px 10px 0; 
    box-sizing: border-box;
    align-items: center;
    @media (max-width: 1400px) {
        padding-right: 60px;
        width: 50%;
    }
    @media (max-width: 1200px) {
        padding-right: 30px;        
    }
    @media (max-width: 1000px) {
        width: 100%;
        border-right: 0;
        border-bottom: 1px solid ${COLORS.grey};
        padding: 10px 0 28px 0; 
    }
    @media (max-width: 500px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 10px 0 20px 0; 
    }
`;

const RouterSpeed = styled.div`
    width: 50%;
    padding: 10px 0 10px 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width: 1400px) {
        padding-left: 60px;
    }
    @media (max-width: 1200px) {
        padding-left: 50px;
    }
    @media (max-width: 1000px) {
        width: 100%;
        padding-left: 0;
    }
`;

const LineSpeed = styled.div`
    :first-child {
        margin-bottom: 28px;
    }
    @media (max-width: 1000px) {
        margin: 28px 0 0 0;
        :first-child {
            margin-bottom: 0;
        }
    }
    @media (max-width: 500px) {
        margin-top: 10px;
        :first-child {
            margin-bottom: 5px;
        }
    }
`;

const LineInfo = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    ${FONTS.L};
    align-items: center;
    @media (max-width: 1200px) {
        ${FONTS.S};
    }
    @media (max-width: 500px) {
        flex-direction: column-reverse;
        align-items: flex-start;
    }
`;

const Recommendation = styled.div`
    ${FONTS.S};
    color: ${ COLORS.red };
    @media (max-width: 1200px) {
        ${FONTS.XS};
    }
    @media (max-width: 1000px) {
        ${FONTS.XS};
    }
    @media (max-width: 500px) {
        ${FONTS.XXS};
    }
`;

const RouterModel = styled.div`
    ${FONTS.XXL};
    color: ${ COLORS.black };
    margin: 5px 0;
    @media (max-width: 1200px) {
        ${FONTS.S};
    }
    @media (max-width: 1000px) {
        ${FONTS.XXL};
        margin: 5px 0 10px;
    }
    @media (max-width: 500px) {
        ${FONTS.S};
        margin: 5px 0;
    }
`;

const GreyInfo = styled.div`
    color: ${ COLORS.grey };
    ${FONTS.XS};
`;

const PropertyType = styled.div`
    color: ${ COLORS.grey };
    ${FONTS.XS};
    @media (max-width: 500px) {
        ${FONTS.XXS};
    }
`;

const Info = styled.div`
    display: flex;
    flex-direction: column;    
    justify-content: center;
    width: 100%;
`;

const ClientRouterIcon = styled.img`
    width: 82px;
    height: 82px;
    display: flex;
    box-sizing: content-box;
    flex-shrink: 0;
    margin-right: 45px;
    @media (max-width: 1200px) {
        margin-right: 25px;
        width: 64px;
        height: 64px;
    }
    @media (max-width: 500px) {
        margin-bottom: 10px;
        width: 50px;
        height: 50px;
    }
`;

const ClientRouter = (props) => {
    const { clientRouter } = props;
    return (
        <ClientRouterContainer>
            <RouterInfo>
                <ClientRouterIcon src={ clientRouterIcon }/>
                <Info>
                    <PropertyType>{ clientRouter.costType }</PropertyType>
                    <RouterModel>Ваш роутер: { clientRouter.materialsEnsName }</RouterModel>
                    <Recommendation>{clientRouter.maxSpeed < clientRouter.planSpeed ? 'Рекомендуем вам заменить роутер на более мощный' : null}</Recommendation>
                </Info>
            </RouterInfo>
            <RouterSpeed>
                <LineSpeed>
                    <LineInfo>
                        { clientRouter.maxSpeed } Мбит/с
                        <GreyInfo>Скорость Wi-Fi соединения</GreyInfo>
                    </LineInfo>
                    <SolidProgressBar width={3}
                                      borderRadius={1.5}
                                      color='#DB5858'
                                      background={ COLORS.grey }
                                      progress={ +clientRouter.routerSpeed / +clientRouter.planSpeed }/>
                </LineSpeed>
                <LineSpeed>
                    <LineInfo>
                        { clientRouter.planSpeed } Мбит/с
                        <GreyInfo>Скорость по тарифу</GreyInfo>
                    </LineInfo>
                    <SolidProgressBar width={3}
                                      borderRadius={1.5}
                                      color={ COLORS.lightGreen }
                                      background={ COLORS.grey }
                                      progress={1}/>
                </LineSpeed>
            </RouterSpeed>
        </ClientRouterContainer>
    );
};

export default memo(ClientRouter);
